import giveaway from "../giveape.gif";

function GiveawayLink() {
  window.open("https://discord.gg/", "_blank");
}

function GiveawayNFT() {
  return (
    <div>
      <img
        style={{
          cursor: "pointer",
          marginTop: "70px",
          marginBottom: "5px",
          alignSelf: "center",
          borderRadius: "10px",
          boxShadow:
            "rgb(0 0 0 / 50%) 0px 0px 0.25rem, rgb(239 0 255 / 50%) -0.125rem -0.125rem 1rem, rgb(0 43 255 / 50%) 0.125rem 0.125rem 1rem",
          // boxShadow: "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
        }}
        alt={"banner"}
        src={giveaway}
        onClick={() => GiveawayLink()}
        className="button"
      />
    </div>
  );
}

export default GiveawayNFT;
